module.exports = __webpack_public_path__ + "img/reminderPlans.d51125ca.svg";